<h1 mat-dialog-title>
  {{title}}
</h1>

<div mat-dialog-content>
  <p>{{message}}</p>
</div>

<div mat-dialog-actions>
  <button mat-button (click)="onDismiss()">{{'BUTTONS.NO' | translate}}</button>
  <button mat-raised-button color="primary" (click)="onConfirm()">{{'BUTTONS.YES' | translate}}</button>
</div>
